var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSetor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46.331,
    height: 31.466,
    viewBox: "0 0 46.331 31.466",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(-6.015 -8.896)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_20",
    "data-name": "Caminho 20",
    d: "M25.5,23.371l-7.183,3.148-.521.232-2.761,1.214v-2.3l-.018-7.761,7.722-1.158.637.211Z",
    transform: "translate(14.204 12.396)",
    fill: "#cee8f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_21",
    "data-name": "Caminho 21",
    d: "M28.1,21.688l-.637-.211-7.722,1.158-.193.039-7.2-3.166-.327.1L12.7,17.54l1.256-3.785h11.5Z",
    transform: "translate(9.477 7.669)",
    fill: "#62c0bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22",
    "data-name": "Caminho 22",
    d: "M21.5,26.874v2.3L10.919,24.577l1.834-5.5.463-1.371v-.019l.54-1.6.328-.1,7.2,3.166.193-.039Z",
    transform: "translate(7.74 11.19)",
    fill: "#82c0e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_23",
    "data-name": "Caminho 23",
    d: "M19.742,22.134v.5l-.193.039-7.2-3.166-.327.1L12.7,17.54l1.256-3.785H19.7l.018,6.892v.58Z",
    transform: "translate(9.477 7.669)",
    fill: "#0d9f9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_24",
    "data-name": "Caminho 24",
    d: "M21.459,16.024l-.521,1.583-2.3,6.892L6.015,28.07l6.41-9.594h.327Z",
    transform: "translate(0 11.25)",
    fill: "#cee8f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_25",
    "data-name": "Caminho 25",
    d: "M19.5,13.755,18.231,17.54l-.7,2.065L8.828,22.057H8.5l1.544-2.318,3.61-5.4.116-.193.848-.059Z",
    transform: "translate(3.924 7.669)",
    fill: "#62c0bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_26",
    "data-name": "Caminho 26",
    d: "M33.013,26.794,20.387,23.242l-.289-.869-1.833-5.541,7.722,2.452,1.428.464.908.021Z",
    transform: "translate(19.334 12.525)",
    fill: "#42a2d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_27",
    "data-name": "Caminho 27",
    d: "M29.942,24.614l-.908-.021-1.428-.464-7.722-2.452h-.021l-.25-.753-.443-1.39h-.021l-1.91-5.773,3.589.253,2.124.134,5.5,8.243Z",
    transform: "translate(17.714 7.68)",
    fill: "#0e8e87"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_28",
    "data-name": "Caminho 28",
    d: "M28.353,25.112l-8.089-2.278L18.43,17.293h-.019l-.251-.753,6.294,2.008.907.019.792,1.178,2.915,4.363a.659.659,0,0,1-.714,1Z",
    transform: "translate(19.167 12.065)",
    fill: "#82c0e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_29",
    "data-name": "Caminho 29",
    d: "M26.815,22.953l-.908-.021-6.294-2.008-.443-1.39h-.021l-1.91-5.773,3.589.253,4.5,6.719Z",
    transform: "translate(17.714 7.68)",
    fill: "#0d9f9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_30",
    "data-name": "Caminho 30",
    d: "M43.733,22.355l-.908-.021-9.15-2.916h-.021l-.637-.211L25.3,20.365,25.1,20.4l-7.2-3.166-.327.1h-.039L8.828,19.787H8.5l1.544-2.318,7.993-2.277.193.077h.018l7.026,3.107.1.039,7.567-1.14h.021l.229-.039,9.055,2.9Z",
    transform: "translate(3.924 9.938)",
    fill: "#ffca78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_31",
    "data-name": "Caminho 31",
    d: "M15.011,16.654l.021.907c.761-.019,1.336-.212,1.336-.463C16.368,16.866,15.772,16.673,15.011,16.654Z",
    transform: "translate(14.198 12.244)",
    fill: "#ed8e06"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32",
    "data-name": "Caminho 32",
    d: "M14.467,17.1c0,.27.576.463,1.278.463h.126l-.018-.907h-.108C15.043,16.654,14.467,16.847,14.467,17.1Z",
    transform: "translate(13.339 12.244)",
    fill: "#e86a15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_33",
    "data-name": "Caminho 33",
    d: "M12.306,15.894v.077a7,7,0,0,0,.6,2.741,4.135,4.135,0,0,0,.386.772L19.2,29.35,25.26,19.6A7.164,7.164,0,0,0,26.3,15.894a7,7,0,0,0-14,0Z",
    transform: "translate(9.928)",
    fill: "#f4a095"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_34",
    "data-name": "Caminho 34",
    d: "M14.984,29.344,21.045,19.6a7.165,7.165,0,0,0,1.042-3.707A7,7,0,0,0,15.235,8.9a7.033,7.033,0,0,1,5.483,6.834,7.164,7.164,0,0,1-1.043,3.706Z",
    transform: "translate(14.155 0.007)",
    fill: "#f07355"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_3",
    "data-name": "Elipse 3",
    cx: 3.369,
    cy: 3.369,
    r: 3.369,
    transform: "translate(25.875 12.234)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetor);
export default __webpack_public_path__ + "static/media/setor.c2180d812b1e296e8d68cedac7cb57dc.svg";
export { ForwardRef as ReactComponent };